import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const TaSignalConfig = React.lazy(() =>
    import('../TaSignalConfig')
);
const taSignalConfigRoutesRegistry = [
    {
        path: PAGE_URL.TA_SIGNAL_CONFIG_PAGE,
        element: <TaSignalConfig />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default taSignalConfigRoutesRegistry;
